import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface ResetPasswordByEmailPayload {
  userId: string;
  token: string;
  password: string;
  confirmPassword: string;
}
export interface ResetPasswordService {
  getResetOptions: (userName: string) => angular.IPromise<apsViewModels.PasswordResetOptions>;
  submitEmailPasswordReset: (payload: ResetPasswordByEmailPayload) => angular.IPromise<any>;
  submitQuestionPasswordReset: (payload: any) => angular.IPromise<any>;
  sendResetPasswordEmail: (userName: string) => angular.IPromise<any>;
}

export default angular
  .module('aps.services.resetPassword', [HttpServiceName])
  .service('resetPasswordService', function(httpService: HttpService): ResetPasswordService {

    var getResetOptions = (userName: string) => {
      return httpService.get<apsViewModels.PasswordResetOptions>(Endpoints.RESET_PASSWORD, {
        userName: userName
      });
    };

    var submitEmailPasswordReset = (payload: ResetPasswordByEmailPayload) => {
      return httpService.post(Endpoints.RESET_PASSWORD_EMAIL, payload);
    };

    var submitQuestionPasswordReset = (payload: any) => {
      return httpService.post(Endpoints.RESET_PASSWORD_QUESTION, payload);
    };

    var sendResetPasswordEmail = (userName: string) => {
      return httpService.post(Endpoints.SEND_RESET_PASSWORD_EMAIL, {
        userName: userName
      });
    };

    return {
      getResetOptions: getResetOptions,
      submitEmailPasswordReset: submitEmailPasswordReset,
      submitQuestionPasswordReset: submitQuestionPasswordReset,
      sendResetPasswordEmail: sendResetPasswordEmail
    };
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/services/resetPassword/resetPassword.service.ts